var _style, _linearGradient, _linearGradient2, _linearGradient3, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAtdLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "13.3333in",
    height: "9.99999in",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 13333 10000",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n  .fil0 {fill:none}\r\n  .fil2 {fill:url(#id0)}\r\n  .fil5 {fill:url(#id1)}\r\n  .fil3 {fill:url(#id2)}\r\n  .fil4 {fill:url(#id3)}\r\n  .fil1 {fill:url(#id4);fill-rule:nonzero}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "id0",
    gradientUnits: "userSpaceOnUse",
    x1: 9058.5,
    y1: 5960.47,
    x2: 9058.5,
    y2: 2971.68
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#FDE689"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0588235,
    style: {
      stopOpacity: 1,
      stopColor: "#FDE689"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258824,
    style: {
      stopOpacity: 1,
      stopColor: "#986C39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368627,
    style: {
      stopOpacity: 1,
      stopColor: "#FDE689"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54902,
    style: {
      stopOpacity: 1,
      stopColor: "#ECCD76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.721569,
    style: {
      stopOpacity: 1,
      stopColor: "#C49F4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878431,
    style: {
      stopOpacity: 1,
      stopColor: "#F4D77C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#8E5F37"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "id1",
    gradientUnits: "userSpaceOnUse",
    x1: 4584.44,
    y1: 6097.61,
    x2: 5211.82,
    y2: 4565.37
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#E5E2E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258824,
    style: {
      stopOpacity: 1,
      stopColor: "#8E8C91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521569,
    style: {
      stopOpacity: 1,
      stopColor: "#F1F3F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878431,
    style: {
      stopOpacity: 1,
      stopColor: "#848085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#D2D4D4"
    }
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id2",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id0",
    x1: 4892.88,
    y1: 5954.57,
    x2: 4892.88,
    y2: 2986.99
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id3",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id1",
    x1: 6348.51,
    y1: 6185.81,
    x2: 7767.59,
    y2: 2720.04
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id4",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id1",
    x1: 5793.32,
    y1: 8749.98,
    x2: 7540.01,
    y2: 4484.06
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil0",
    width: 13333,
    height: 10000
  }), /*#__PURE__*/React.createElement("g", {
    id: "_1401340736"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M1755 6778l0 223 -166 0 0 -462c0,-148 92,-259 278,-333 185,74 278,185 278,333l0 462 -167 0 0 -223 -223 0zm223 -139l0 -155c0,-19 -37,-54 -111,-106 -75,52 -112,87 -112,106l0 155 223 0zm391 -417l0 556c0,56 37,84 111,84 74,0 112,-28 112,-84l0 -556 166 0 0 556c0,148 -92,223 -278,223 -185,0 -278,-75 -278,-223l0 -556 167 0zm790 139l0 667 -167 -27 0 -640 -194 0 0 -139 556 0 0 139 -195 0zm576 417l0 -333c0,-56 -37,-84 -111,-84 -75,0 -112,28 -112,84l0 333c0,56 37,84 112,84 74,0 111,-28 111,-84zm-389 0l0 -333c0,-148 92,-223 278,-223 185,0 278,75 278,223l0 333c0,148 -93,223 -278,223 -186,0 -278,-75 -278,-223zm1159 -417l0 667 -166 -27 0 -640 -195 0 0 -139 556 0 0 139 -195 0zm400 -139l0 806 -167 -27 0 -779 167 0zm400 139l0 667 -166 -27 0 -640 -195 0 0 -139 556 0 0 139 -195 0zm233 501l0 -640 167 0 0 640 333 0 0 139 -500 0 0 -139 0 0zm704 0l333 0 0 139 -500 0 0 -139 0 0 0 -195 0 0 0 -139 0 0 0 -167 0 0 0 -139 500 0 0 139 -333 0 0 167 278 0 0 139 -278 0 0 195zm854 -640c185,0 278,75 278,223l0 333c0,148 -93,223 -278,223l-278 0 0 -779 278 0zm111 223c0,-56 -37,-84 -111,-84l-112 0 0 501 112 0c74,0 111,-28 111,-84l0 -333zm387 -223l0 806 -166 -27 0 -779 166 0zm377 0c185,0 278,75 278,223l0 28c0,65 -18,116 -54,152 36,37 54,88 54,153l0 28c0,37 6,102 17,195l-167 0c-11,-93 -17,-158 -17,-195l0 -28c0,-55 -37,-83 -111,-83l-111 0 0 306 -167 0 0 -779 278 0zm0 334c74,0 111,-28 111,-83l0 -28c0,-56 -37,-84 -111,-84l-111 0 0 195 111 0zm504 306l334 0 0 139 -500 0 0 -139 0 0 0 -195 0 0 0 -139 0 0 0 -167 0 0 0 -139 500 0 0 139 -333 0 0 167 277 0 0 139 -278 0 0 195zm729 -111l167 27c0,148 -93,223 -278,223 -186,0 -278,-75 -278,-223l0 -333c0,-148 92,-223 278,-223 185,0 278,75 278,223l-167 28c0,-75 -37,-112 -111,-112 -75,0 -112,28 -112,84l0 333c0,56 37,84 112,84 74,0 111,-37 111,-111zm518 -390l0 667 -166 -27 0 -640 -195 0 0 -139 556 0 0 139 -195 0zm438 501l0 -640 167 0 -1 640 334 0 0 139 -500 0 0 -139 0 0zm537 0l0 -640 167 0 -1 640 334 0 0 139 -500 0 0 -139 0 0zm881 -111l167 27c0,148 -93,223 -278,223 -186,0 -278,-75 -278,-223l0 -333c0,-148 92,-223 278,-223 185,0 278,75 278,223l-167 28c0,-75 -37,-112 -111,-112 -75,0 -112,28 -112,84l0 333c0,56 37,84 112,84 74,0 111,-37 111,-111z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M8588 3697c364,17 920,-49 1200,62 44,159 65,1336 -21,1430 -98,107 -1228,87 -1428,50l-4 -1338 -860 2 1 2048c672,20 1368,1 2040,2 747,1 1108,-161 1109,-928 0,-536 110,-1527 -224,-1819 -330,-289 -1282,-240 -1810,-214l-3 705z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M2691 5945l1023 10c72,-130 1073,-2077 1204,-2193l1160 2190 1017 1 -1599 -2966 -1183 2 -1622 2956z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil4",
    d: "M6051 3674l308 5c0,702 -32,491 360,1225 182,342 372,703 564,1014l5 -2241 1131 -3 3 -675 -2728 -11 357 686z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil5",
    d: "M4234 5954l1328 -1 -656 -1244c-60,57 -641,1137 -672,1245z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtdLogo);
export default __webpack_public_path__ + "static/media/atd-logo.849180f9c4722c2c3a02a7bc5de1a46b.svg";
export { ForwardRef as ReactComponent };